import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'state/store';

export type PeakSaveState = {
  data: {
    hasPeakSaveConsent: boolean;
  };
};

export const initialState: PeakSaveState = {
  data: {
    hasPeakSaveConsent: false
  }
};

export const slice = createSlice({
  name: 'peakSave',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setPeakSaveConsent: (state, { payload }) => {
      state.data.hasPeakSaveConsent = payload;
    }
  }
});

export const { setPeakSaveConsent, setInitialState } = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectSliceData = (state: RootState) => selectSlice(state).data;
export const selectPeakSaveConsent = (state: RootState) =>
  selectSliceData(state).hasPeakSaveConsent;

export default slice.reducer;
